import  gql  from 'graphql-tag'

export const creditTypes = gql`query creditTypes($isActive: Boolean){ 
    creditTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
